import 'babel-polyfill';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';

// Mensajes
import messages from '@/locale/messages';

// Import stylesheet
import 'normalize.css/normalize.css';
import '@/resources/styles/index.scss';
import '@/resources/styles/custom-vuetify.scss';

// plugins
import '@/plugin/vuetify';
import '@/plugin/moment';
import '@/plugin/math';
import '@/plugin/toastr';
import '@/plugin/vuelidate';
import '@/security';
import '@/error/index';
import '@/utils/utils';

// Filtros
import * as filters from '@/filters';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// Internacionaliacion
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'es',
  messages
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

/* eslint-disable no-unused-vars */
window.onerror = function(message, source, lineno, colno, error) {};
/* eslint-enable no-unused-vars */
